var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1368 23.4274L19.4833 19.902C19.2417 19.752 18.9579 19.6846 18.6745 19.7099C18.3912 19.7352 18.1237 19.8518 17.9123 20.0422L14.7257 22.9052C10.8243 20.2744 7.96069 16.3677 6.62621 11.8553L10.3156 9.6783C10.5612 9.53441 10.7532 9.31445 10.8627 9.05174C10.9721 8.78902 10.993 8.49785 10.9221 8.22231L9.26191 1.76984C9.18336 1.47248 9.00348 1.21189 8.7533 1.03301C8.50311 0.85413 8.19829 0.768172 7.89141 0.789957L2.06969 1.22255C1.77366 1.24459 1.49378 1.3663 1.27575 1.56782C1.05771 1.76934 0.914397 2.03876 0.869186 2.33212C-1.27056 16.1956 8.23606 29.1389 22.079 31.2679C22.3724 31.3133 22.6726 31.2578 22.9305 31.1105C23.1885 30.9632 23.3889 30.7329 23.499 30.4572L25.6639 25.0356C25.7768 24.748 25.786 24.4301 25.6898 24.1366C25.5936 23.8431 25.398 23.5923 25.1368 23.4274Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.504992de0743bcbfc5b526ebbdad6e75.svg";
export { ForwardRef as ReactComponent };